import React from 'react';
import { UserTeamType } from '../../../types';
import FireTeamList from './FireTeamList';

const DisplayUserTeam = ({ team: { fireTeams } }: { team: UserTeamType }): JSX.Element => {
  return <FireTeamList fireTeams={fireTeams} />;
};

export default DisplayUserTeam;
